import {realysList} from "../../lists/relays-list";
import {irdaList} from "../../lists/irda-list";
import {temperatureList} from "../../lists/temperature-list";
import {humidityList} from "../../lists/humidity-list";
import {inputsList} from "../../lists/inputs-list";
import {analogOutputList, manualSettingsList} from "../../lists/analogOutput-list";

const analogInputList = [
    {
        key: 'analog2',
        label: 'analog2',
        value: 0
    }
]
export const optionalMenuDevice = {
    value: {
        sensors: {
            header: 'relays',
            items: realysList
        },
        irda: {
            header: 'irda',
            items: irdaList
        },
        analogOutput: {
            header: 'analogOutput',
            items: analogOutputList
        },
        manualSettings: {
            header: 'manualSettings',
            items: manualSettingsList
        }
    }
}

export const optionalMenuOptions = {
    value: {
        options: {
            header: 'options',
            items: [
                {
                    key: 'phones',
                    label: 'phones'
                },
                {
                    key: 'email',
                    label: 'emails'
                },
                {
                    key: 'name',
                    label: 'names'
                },
                // {
                //     key: 'modbus',
                //     label: 'modbus'
                // },
                {
                    key: 'irda-settings',
                    label: 'irda'
                },
                {
                    key: 'general',
                    label: 'general'
                }
            ]
        },
    }
}

export const optionalMenuAlarms = {
    value: {
        temperature: {
            header: 'temperature',
            items: temperatureList
        },
        humidity: {
            header: 'humidity',
            items: humidityList
        },
        inputs: {
            header: 'inputs-title',
            items: inputsList
        },
        analogInputs: {
            header: 'analogInputs',
            items: analogInputList
        },
    }
}